import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { saveAs } from "file-saver";
//--------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import {
    myAxios, 
    MyFormData, 
    mimeTypeMap, 
    numberReducer, 
    MyDate, 
    isDevMode, 
    simpleStatusColorCode,
    onlyUnique, 
} from "src/components/common/functions";
export default function CurrentMaterialCost({    
    updateDateTime, // Purchases, Work Logs
    projectHashKey, 
    projectName, 
    className, 
    uid, 
}){
    const [isOpen, setIsOpen] = useState(false);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [dates, setDates] = useState([]);
    const history = useHistory();
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const allPurchases = useMyStore(state => state.billingPurchases);
    const setPurchases = useMyStore(state => state.setBillingPurchases);
    const purchases = allPurchases[projectHashKey] ?? [];
    const filteredPurchases = purchases.filter(purchase => fromDate && toDate ? purchase.submitTime >= fromDate && purchase.submitTime <= toDate: true);
    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();
        const getData = async() => {
            if(isDevMode) console.log("useEffect currentMaterialCost");
            const formData = new MyFormData();
            formData.append("projectHashKey", projectHashKey);
            //---------------------------------------------------------------------
            setShowLoader(true);
            const resPurchases = await myAxios("common/readProjectPurchase.php", formData);
            if(!isMounted) return;
            setShowLoader(false);
            if(!resPurchases) return;
            //---------------------------------------------------------------------
            setDates(resPurchases.data.map(purchase => purchase.submitTime).filter(onlyUnique).sort());
            setPurchases(
                projectHashKey, 
                resPurchases.data.map(purchase => 
                    ({
                        ...purchase, 
                        decision:
                            JSON.parse(purchase.approval).filter(approvalLevel => approvalLevel.approverDecision === "Rejected").length > 0?
                            "Rejected"
                            :
                            JSON.parse(purchase.approval).filter(approvalLevel => approvalLevel.approverDecision !== "Approved").length === 0?
                            "Approved"
                            :
                            ""
                    })
                ), 
                updateDateTime["Purchases"]
            );
        }
        if(
            isOpen && (
                !allPurchases[projectHashKey] || (updateDateTime["Purchases"] !== allPurchases.updatedAt)
            )
        ) getData();
        return () => {
            isMounted = false;
            controller.abort();
            setShowLoader(false);
        }
    }, [updateDateTime, isOpen, allPurchases, projectHashKey, setPurchases, setShowLoader])
    //--------------------------------------------------------------------------------------------
    return(
        <details className = {className ?? "my-4 mx-5"} open = {isOpen} onToggle = {e => {
            setIsOpen(e.currentTarget.open);
        }}>
            <summary>
                Current Material Cost
                {allPurchases[projectHashKey] === undefined?<></>:
                <span className = "ml-2 badge badge-primary">
                    ${filteredPurchases.length?filteredPurchases.map(purchase => window.Number.parseFloat(purchase.total)).reduce(numberReducer, 0).toFixed(2):0}
                </span>}
            </summary>
            {purchases.length > 1?
            <div className = "d-flex align-items-center my-2">
                <span className = "font-weight-bold">PO Date Created</span>
                <label htmlFor = {"from" + uid} className = "mb-0 ml-3">From</label>
                <select
                    id = {"from" + uid}
                    className = "form-control w-auto ml-2"
                    value = {fromDate}
                    onChange = {e => setFromDate(e.currentTarget.value)}
                >
                    <option value = {""}>Select</option>
                    {dates.map((value, key) => <option key = {key}>{value}</option>)}
                </select>
                <label htmlFor = {"to" + uid} className = "mb-0 ml-3">To</label>
                <select
                    id = {"to" + uid}
                    className = "form-control w-auto ml-2"
                    value = {toDate}
                    onChange = {e => setToDate(e.currentTarget.value)}
                >
                    <option value = {""}>Select</option>
                    {dates.map((value, key) => <option key = {key}>{value}</option>)}
                </select>
            </div>
            :<></>}
            {filteredPurchases.length > 1?<>
            <div>
                <span
                    className = "btn btn-success ml-2 mt-2"
                    onClick = {async () => {
                        if(!window.confirm("Are you sure to download all POs Forms?")) return;
                        const formData = new MyFormData();
                        for(const purchase of filteredPurchases){
                            formData.append("fileName[]", `${purchase.poNumber}.pdf`);
                            formData.append("fileId[]", purchase.formId);
                        }
                        //-------------------------------------------------------------------
                        setShowLoader(true);
                        const res = await myAxios("common/getFile.php", formData, "blob");
                        setShowLoader(false);
                        if(!res) return;
                        //-------------------------------------------------------------------
                        const now = new MyDate();
                        saveAs(new Blob([res.data], {type: mimeTypeMap.zip}), `${projectName}  PO Forms Downloaded at ${now.s()} ${now.ss()}.zip`);
                    }}
                >
                    Download All Forms
                </span>
                <span
                    className = "btn btn-success ml-2 mt-2"
                    onClick = {async () => {
                        if(!window.confirm("Are you sure to download all POs Receipts?")) return;
                        // window.alert("WARNING: You are downloading APPROVED POs only. You will still need to verify that there are no remaining job tags assigned to this BTL. You MUST verify all JOB TAGS are approved and current in order to proceed with the billing process.");
                        const formData = new MyFormData();
                        for(const purchase of filteredPurchases){
                            formData.append("fileName[]", `${purchase.poNumber} receipt.pdf`);
                            formData.append("fileId[]", purchase.receiptLink.split("/")[5]);
                        }
                        //-------------------------------------------------------------------
                        setShowLoader(true);
                        const res = await myAxios("common/getFile.php", formData, "blob");
                        setShowLoader(false);
                        if(!res) return;
                        //-------------------------------------------------------------------
                        const now = new MyDate();
                        saveAs(new Blob([res.data], {type: mimeTypeMap.zip}), `${projectName}  PO Receipts Downloaded at ${now.s()} ${now.ss()}.zip`);
                    }}
                >
                    Download All Receipts
                </span>
                <span
                    className = "btn btn-success ml-2 mt-2"
                    onClick = {async () => {
                        if(!window.confirm("Are you sure to download all POs?")) return;
                        // window.alert("WARNING: You are downloading APPROVED POs only. You will still need to verify that there are no remaining job tags assigned to this BTL. You MUST verify all JOB TAGS are approved and current in order to proceed with the billing process.");
                        const formData = new MyFormData();
                        for(const purchase of filteredPurchases){
                            formData.append("fileName[]", `${purchase.poNumber}.pdf`);
                            formData.append("fileId[]", purchase.formId);
                        }
                        for(const purchase of filteredPurchases){
                            formData.append("fileName[]", `${purchase.poNumber} receipt.pdf`);
                            formData.append("fileId[]", purchase.receiptLink.split("/")[5]);
                        }
                        //-------------------------------------------------------------------
                        setShowLoader(true);
                        const res = await myAxios("common/getFile.php", formData, "blob");
                        setShowLoader(false);
                        if(!res) return;
                        //-------------------------------------------------------------------
                        const now = new MyDate();
                        saveAs(new Blob([res.data], {type: mimeTypeMap.zip}), `${projectName}  PO Receipts Downloaded at ${now.s()} ${now.ss()}.zip`);
                    }}
                >
                    Download All
                </span>
            </div>
            </>:<></>}
            {filteredPurchases.length?filteredPurchases.map((purchase, key) =>
                <details key = {key} className = "mt-2">
                    <summary style = {{color: simpleStatusColorCode[purchase.decision]}}>
                        {purchase.poNumber}
                        <span className = "badge badge-secondary ml-2">{purchase.submitTime}</span>
                        <span className = "badge badge-primary ml-2">${purchase.total}</span>
                        <span className = "badge badge-success ml-2">{purchase.billable}{purchase.includedInProposal === "Yes"?`, but included in proposal`:""}</span>
                        <a className = "btn btn-primary ml-2" href = {`https://drive.google.com/uc?export=download&id=${purchase.formId}`} target = "_blank" rel = "noreferrer">Form</a>
                        <a className = "btn btn-info ml-2" href = {`https://drive.google.com/uc?export=download&id=${purchase.receiptLink.split("/")[5]}`} target = "_blank" rel = "noreferrer">Receipt</a>
                    </summary>
                    <div> <span className = "btn btn-primary m-2" onClick = {() => {history.push(`/Purchases/${purchase.poNumber}`)}}>Detail</span></div>
                    <table className = "m-1">
                        <thead>
                            <tr>
                                <th>Vendor</th>
                                <th>Description</th>
                                <th>Unit Price</th>
                                <th>Quantity</th>
                                <th>Line Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {JSON.parse(purchase.data).map((dd, keyd) => <tr key = {keyd}>
                                <td>{dd.vendorName}</td>
                                <td>{dd.projectDescription}</td>
                                <td>{dd.unitPrice}</td>
                                <td>{dd.quantity}</td>
                                <td>{dd.lineTotal}</td>
                            </tr>)}
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>Subtotal</td>
                                <td>{purchase.subtotal}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>Tax</td>
                                <td>{purchase.tax}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>Discount</td>
                                <td>{purchase.discount}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>Total</td>
                                <td>{purchase.total}</td>
                            </tr>
                        </tbody>
                    </table>
                </details>
            ):<></>}
        </details>
    )
}